/**
 * Zeitzone des Browsers mit stabilem Fallback. Zentraler Helper statt
 * ad-hoc wiederholtem `Intl.DateTimeFormat().resolvedOptions().timeZone`.
 */
export function getSystemTimeZone(fallback = "Europe/Berlin"): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || fallback;
  } catch {
    return fallback;
  }
}

/**
 * Auswählbare Zeitzonen für die Benutzereinstellungen. Ältere Browser kennen
 * `Intl.supportedValuesOf` nicht — dann bleibt eine kurze, gängige Auswahl.
 */
export function getSelectableTimeZones(): string[] {
  try {
    return Intl.supportedValuesOf("timeZone");
  } catch {
    return [
      "Europe/Berlin",
      "Europe/London",
      "Europe/Paris",
      "Europe/Zurich",
      "Europe/Vienna",
      "Europe/Rome",
      "UTC",
      "America/New_York",
      "America/Los_Angeles",
      "America/Chicago",
      "Asia/Tokyo",
      "Asia/Shanghai",
      "Australia/Sydney",
    ];
  }
}
